export const projects = [
  {
    title: "MergeSort Benchmark",
    subtitle: "Java Stack/Swing GUI",
    description:
      "Runs a simple benchmark, both recursively and iteratively, on the MergeSort algorithm. Then allows the user to display the report in a JTable.",
    image: "./MergeSortBenchmarker.gif",
    link: "https://github.com/SpencerBrown1452/MergeSortBenchmark",
  },
  {
    title: "React Tracks",
    subtitle: "React and Python",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
    image: "./Work_in_Progress.png",
    link: "#",
  },
  {
    title: "DevChat",
    subtitle: "React and Firebase",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
    image: "./Work_in_Progress.png",
    link: "#",
  },
  {
    title: "Epic Todo App",
    subtitle: "React Hooks",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
    image: "./Work_in_Progress.png",
    link: "#",
  },
];

export const testimonials = [
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/1.jpg",
    name: "Jesse Hicks",
    company: "Zoozle",
  },
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/94.jpg",
    name: "Ruben Alvarez",
    company: "Dooble.io",
  },
];

export const skills = [
  "HTML", 
  "CSS", 
  "JavaScript",
  "Node",
  "React",
  "Java",
  "Python",
  "MySQL", 
  "MSSQL",
  "Technical Writing"
];

export const experiences = [
  {
    title: "Software Technical Analyst",
    company: "Inductive Automation",
    timeline: "May 2021 - Present",
  },
  {
    title: "Aircrew Egress Systems Craftsman",
    company: "United States Air Force",
    timeline: "Feb 2014 - April 2021",
  },
  {
    title: "IT Manager",
    company: "United States Air Force",
    timeline: "April 2019 - April 2020",
  },
  {
    title: "Cybersecurity Liaison",
    company: "United States Air Force",
    timeline: "April 2019 - April 2020",
  },
];



// WEBPACK FOOTER //
// ./src/data.js